import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { format } from "date-fns";
import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { CloseTemplateRow } from "../organizationCloseTemplatesViewConfig";

export const CloseTemplateLastAppliedCell = memo(
    ({
        row,
    }: CellContext<ViewTableFeatures, CloseTemplateRow, Date | null>) => (
        <ViewTableCell>
            {row.original.lastAppliedAt ? (
                <span>{format(row.original.lastAppliedAt, "MMM d, yyyy")}</span>
            ) : (
                <span>-</span>
            )}
        </ViewTableCell>
    ),
);
